import React, { useEffect } from "react";
import { Animated } from "react-native";
import { useAppTheme } from "../../../useAppTheme";
import Box from "../../Box";

export type Props = Record<string, never>;

const ProcessingMessage = (_props: Props) => {
	const theme = useAppTheme();
	const opacity = React.useRef(new Animated.Value(0)).current;
	const innerCircleScale = React.useRef(new Animated.Value(1)).current;
	useEffect(() => {
		const animation = Animated.loop(
			Animated.sequence([
				Animated.timing(opacity, {
					toValue: 1,
					duration: 1000,
					useNativeDriver: true,
				}),
				Animated.timing(opacity, {
					toValue: 0,
					duration: 1000,
					useNativeDriver: true,
				}),
			]),
		);
		const animation2 = Animated.loop(
			Animated.sequence([
				Animated.timing(innerCircleScale, {
					toValue: 1.3,
					duration: 1000,
					useNativeDriver: true,
				}),
				Animated.timing(innerCircleScale, {
					toValue: 1,
					duration: 1000,
					useNativeDriver: true,
				}),
			]),
		);
		animation.start();
		animation2.start();
		return () => {
			animation.stop();
			animation2.stop();
		};
	}, [opacity, innerCircleScale]);
	return (
		<Box paddingVertical={8} paddingRight={16}>
			<Box
				justifyContent="center"
				alignItems="center"
				alignSelf="flex-start"
				width={24}
				height={24}
			>
				<Animated.View
					style={[
						{
							width: 24,
							height: 24,
							backgroundColor: theme.colors.secondaryContainer,
							borderRadius: 999,
						},
						{ opacity },
					]}
				/>
				<Animated.View
					style={[
						{
							zIndex: 100,
							backgroundColor: theme.colors.onSurfaceVariant,
							borderRadius: 999,
							position: "absolute",
							width: 12,
							height: 12,
							transform: [{ scale: innerCircleScale }],
						},
					]}
				/>
			</Box>
		</Box>
	);
};

export default ProcessingMessage;
